export default "__VITE_ASSET__BhUTyWOi__"